<template>
  <div class="Groupingresult pointer">
    <NavBar title="设备转移结果" />
    <van-loading v-if="publicLoading" class="publicLoading" size="50px" vertical
      >加载中...</van-loading
    >
    <div class="solveBfc">
      <div class="main">
        <img
          class="chengong"
          src="../../../assets/icons/zhifucehnggong_jhm.png"
          alt=""
        />
        <p class="titles">转移成功</p>
        <div v-if="this.unsuccessfulInfo">
          <div class="unsuccessful">
            部分设备转移失败:{{ this.unsuccessfulInfo }}
          </div>
          <div class="unsuccessful">请联系客服处理转移失败设备!</div>
          <van-button type="info" class="copy_btn" @click="issucopy"
            >复制失败设备</van-button
          >
          <van-button type="info" class="service_btn" @click="pageService"
            >联系客服</van-button
          >
        </div>
        <div>
          <van-button type="info" class="cantuan_btn" @click="getBack"
            >完成</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
        
        <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
export default {
  name: "TransferResults",
  components: {
    NavBar,
  },
  data() {
    return {
      publicLoading: false,
      unsuccessfulInfo: "",
    };
  },

  mounted() {
    this.unsuccessfulInfo = this.$route.query.unsuccessful;
  },

  methods: {
    // 回退
    getBack() {
      this.$router.go(-1);
    },
    // 复制
    issucopy() {
      this.copy(this.unsuccessfulInfo);
    },
    pageService() {
      this.$router.push("/clientServe");
    },
    // 复制方法
    copy(value) {
      var aux = document.createElement("input");
      aux.setAttribute("value", value);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      Toast("复制成功！");
    },
  },
};
</script>
        
        <style lang="less" scoped>
.solveBfc::before,
.solveBfc::after {
  content: "";
  /*table既可以解决塌陷又可以解决外边距重叠*/
  display: table;
  clear: both;
}
.Groupingresult {
  padding: 0 0 60px;
}
.main {
  margin: 40px 48px 0 48px;
  .chengong {
    width: 100px;
    height: 100px;
    margin: 30px 0 10px;
  }
  .titles {
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    margin: 0 0 30px 0;
    padding: 0;
  }
  .unsuccessful {
    font-size: 14px;
    color: #666666;
    text-align: left;
    margin-top: 8px;
    max-height: 80px;
    // width: 200px;
    display: -webkit-box; /* 使用旧版弹性盒子模型 */
    -webkit-box-orient: vertical; /* 内容垂直排列 */
    -webkit-line-clamp: 4; /* 限制显示行数 */
    overflow: hidden; /* 隐藏溢出内容 */
  }
}
.copy_btn {
  background-color: #ff1313;
  display: block;
  width: 200px;
  height: 36px;
  border: 0;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 12px;
}
.service_btn {
  background-color: #008c88;
  display: block;
  width: 200px;
  height: 36px;
  border: 0;
  border-radius: 20px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 12px;
}
.cantuan_btn {
  width: 222px;
  height: 46px;
  margin-top: 80px;
  border: none;
  background-color: #886df3;
  line-height: 40px;
  font-size: 24px;
  color: #fff;
  // font-style: italic;
  font-family: Microsoft YaHei;
  font-weight: bold;
  border-radius: 24px;
}
.serviceClass {
  width: 320px;
  background: #ffffff;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 20px 16px;
  .titleTop {
    position: relative;
  }
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: center;
  }
  .imgClose {
    position: absolute;
    width: 24px;
    height: 24px;
    top: -1px;
    right: 0px;
  }
  .content {
    font-size: 14px;
    margin-top: 30px;
    color: #5b5959;
  }
  .but {
    width: 150px;
    height: 40px;
    background: #558bff;
    border-radius: 5px;
    margin-top: 40px;
  }
}
.publicLoading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>